import { IdentityDto } from './identity.dto';
import { EntityDto } from './../entity/entity.dto';

export class FinancialInstrumentDto {
  identity = new IdentityDto();
  type: string;
  rank: number;
  currency: string;

  // @TODO: missing fields on difhub
  entity: EntityDto;
  status = 'Active';
  accountNumber: string;
  country: string;
  routingNumber: string;

  constructor(d?: FinancialInstrumentDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.type = d.type;
    this.rank = d.rank;
    this.currency = d.currency;

    this.entity = new EntityDto(d.entity);
    this.status = d.status;
    this.accountNumber = d.accountNumber;
    this.country = d.country;
    this.routingNumber = d.routingNumber;
  }
}
